import React, { createContext, useContext, useEffect } from "react";

export const AccountHeaderActionsContext = createContext({
  setHeaderActions: () => {},
});

/** Register PC page-header actions (e.g. Add method). Cleared on unmount. */
export function useAccountHeaderActions(actions) {
  const { setHeaderActions } = useContext(AccountHeaderActionsContext);

  useEffect(() => {
    setHeaderActions(actions ?? null);
    return () => setHeaderActions(null);
  }, [actions, setHeaderActions]);
}
